import React from "react";
import { Row, Col, Card, Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { Scrollbars } from "react-custom-scrollbars";
import data from "../../../../constants/retailPos.json";

const OrderTypeSelectionModal = ({
  displaySetOrderType,
  setDisplayOrderType,
  posSaleTypes,
  changeOrderType,
}) => {
  return (
    <Modal
      open={displaySetOrderType}
      closable={false}
      footer={null}
      styles={{ body: { padding: "20px 15px 15px" } }}
    >
      <Row>
        <Col span={14}>
          <p style={data.posScreenStyles.orderTypeSelectionModal.modalTitle}>Order Type</p>
        </Col>
        <Col span={10}>
          <p style={data.posScreenStyles.offerSelectionModal.closeIconP}>
            <CloseOutlined onClick={() => setDisplayOrderType(false)} style={data.posScreenStyles.offerSelectionModal.closeIcon} />
          </p>
        </Col>
      </Row>
      <Row>
        <Card className="orderHistoryCard" style={data.posScreenStyles.cardDetails} styles={{ body: { padding: 10 } }}>
          <Scrollbars className="orderHistoryScroll">
            {posSaleTypes.map((item, index) => (
              <Card
                key={`${item.name}-${index}`}
                style={data.posScreenStyles.orderHistoryModal.oderHistoryDetailsCard}
                styles={{ body: { padding: 20 } }}
                onClick={() => changeOrderType(item)}
              >
                <Row>
                  <Col span={24}>
                    <p style={data.posScreenStyles.orderTypeSelectionModal.orderTypeName}>{item.cwrSaletype.name}</p>
                  </Col>
                </Row>
              </Card>
            ))}
          </Scrollbars>
        </Card>
      </Row>
    </Modal>
  );
};

export default OrderTypeSelectionModal;
